import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { DataDisplayPlain } from '@e2n/ui/v2';
import { useTranslation } from 'react-i18next';

export function DynamischeStundenbewertung() {
  const { t } = useTranslation();
  const form = useAnlageassistentFormContext();
  const data = form.state.values;
  return (
    <>
      <DataDisplayPlain
        orientation="horizontal"
        variant="text"
        label={t(
          'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.stunden.label',
        )}
        item={t(
          'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.dynamisch.zusammenfassung.options.' +
            data.abwesenheiten.allgemein.dynamisch,
        )}
      />
      {data.abwesenheiten.allgemein.dynamisch === 'wochenschnitt' && (
        <>
          <DataDisplayPlain
            orientation="horizontal"
            variant="text"
            label={t(
              'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.dynamisch.zusammenfassung.start_abwesenheitszeit.label',
            )}
            item={`${data.abwesenheiten.allgemein.dynamisch_wochenschnitt_start} ${t(
              'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.dynamisch.zusammenfassung.start_abwesenheitszeit.suffix',
            )}`}
          />
          <DataDisplayPlain
            orientation="horizontal"
            variant="text"
            label={t(
              'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.dynamisch.zusammenfassung.abwesenheitszeit_limitieren.label',
            )}
            item={t(
              'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.dynamisch.zusammenfassung.abwesenheitszeit_limitieren.options.' +
                (data.abwesenheiten.allgemein
                  .dynamisch_wochenschnitt_limitieren ?? false),
            )}
          />
        </>
      )}
      {data.abwesenheiten.allgemein.dynamisch === 'drei_monatsschnitt' && (
        <DataDisplayPlain
          orientation="horizontal"
          variant="text"
          label={t(
            'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.dynamisch.drei_monatsdurchschnitt.berechnungsgrundlage.label',
          )}
          item={t(
            'domain.mitarbeiter.create.steps.abwesenheiten.allgemein.form.dynamisch.drei_monatsdurchschnitt.berechnungsgrundlage.options.' +
              data.abwesenheiten.allgemein
                .dynamisch_drei_monatsschnitt_berechnungsgrundlage,
          )}
        />
      )}
    </>
  );
}
